import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Typography } from '@app-velocity/ui';

import { I18nResources, useI18n } from '@app-velocity/i18n';

export type SectionHeaderProps = {
  title: I18nResources;
  icon?: ReactNode;
  right?: ReactNode;
};

const StyledSectionHeader = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: 13,
  gap: theme.spacing(1),
  justifyContent: 'space-between',
  color: 'var(--text-text-primary-color)',
  svg: {
    fill: 'var(--icon-icon-tertiary-color)',
  },
}));

const StyledPart = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: 13,
  gap: theme.spacing(1),
}));

export const SectionHeader = ({ title, icon, right }: SectionHeaderProps) => {
  const { t } = useI18n();

  return (
    <StyledSectionHeader>
      <StyledPart>
        {t(title)}
        {icon}
      </StyledPart>
      {right ? <StyledPart>{right}</StyledPart> : null}
    </StyledSectionHeader>
  );
};
